// ...existing code...
import React, { useMemo, useRef, useState } from 'react';
import {
  Typography,
  Box,
  TextField,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Button,
  InputAdornment,
  IconButton,
  CircularProgress,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DashboardCard from '../../shared/DashboardCard';
import { useNavigate } from 'react-router';

const EmptyState = () => (
  <Box
    sx={{
      p: 3,
      textAlign: 'center',
      border: '1px dashed',
      borderColor: 'divider',
      borderRadius: 1,
      bgcolor: 'background.paper',
      minHeight: 600,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Typography variant="body1" color="text.secondary">
      No bookings available
    </Typography>
  </Box>
);

const NewBookings = ({ bookingsData = [], setSearchTerm,searchTerm,loading }) => {
  // const [searchTerm, setSearchTerm] = useState('');
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();
  const searchInputRef = useRef(null);
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);

  const handleSearchSubmit = () => {
    setSearchTerm(localSearchTerm);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchSubmit();
    }
  };
  const filteredBookings = bookingsData

  // If showing all, return everything; otherwise limit to 10
  const displayList = useMemo(() => {
    return showAll ? bookingsData : bookingsData.slice(0, 5);
  }, [bookingsData, showAll]);
  
  return (
    <DashboardCard title="New Bookings">
          <Box sx={{ mb: 1 }}>
        <TextField
          fullWidth
          placeholder="Search bookings..."
          value={localSearchTerm}
          onChange={(e) => setLocalSearchTerm(e.target.value)}
          onKeyPress={handleKeyPress}
          inputRef={searchInputRef}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton 
                  onClick={handleSearchSubmit}
                  edge="start"
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={20} /> : <SearchIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          size="small"
          disabled={!bookingsData?.length || loading}
        />
      </Box>

      {!bookingsData?.length || !bookingsData.length ? (
        <EmptyState />
      ) : (
        <>
          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {displayList.map((booking) => (
              <ListItem
                key={booking.townName}
                alignItems="flex-start"
                sx={{
                  mb: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                }}
              >
                <ListItemAvatar>
                  <Avatar>{booking?.customer?.name?.charAt(0)}</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography variant="subtitle1" fontWeight="medium">
                        {booking?.customer?.name}
                      </Typography>
                    </Box>
                  }
                  secondary={
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                      {booking?.property?.propertyName}
                    </Typography>
                  }
                />
                  {/* <Button
                  variant="outlined"
                  size="small"
                  onClick={() => navigate(`/bookings`)}
                  sx={{
                    minWidth: 'auto',
                    height: 32,
                    ml: 2,
                    alignSelf: 'center'
                  }}
                >
                  View
                </Button> */}
              </ListItem>
            ))}
          </List>

          {/* Show All button if more than 10 entries */}
          {bookingsData.length > 4 && (
              <Box sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  onClick={() => navigate('/bookings')}
                  sx={{ mt: 2 }}
                >
                  View All Bookings
                </Button>
              </Box>
            )}
        </>
      )}
    </DashboardCard>
  );
};

export default NewBookings;